import { FC } from 'react';
import { Badge } from '@new/common/ui/Badge/Badge';
import type { TranscriptSystemKind } from '../types';
import { SYSTEM_TRANSCRIPT_LABELS } from '../helpers/systemTranscripts';

interface SystemTranscriptBadgeProps {
  kind: TranscriptSystemKind | null;
}

export const SystemTranscriptBadge: FC<SystemTranscriptBadgeProps> = ({ kind }) =>
  kind ? <Badge variant="blue">{SYSTEM_TRANSCRIPT_LABELS[kind]}</Badge> : null;
